var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8077 14H4.19503C3.51748 14 3.10624 13.2869 3.46882 12.7407L6.616 8L3.46882 3.2593C3.10624 2.71313 3.51748 2 4.19503 2H11.8077C12.2824 2 12.6673 2.36727 12.6673 2.82031V4.21037C12.6673 4.67033 12.2728 5.05552 11.7909 5.04673C11.3239 5.0382 10.948 4.67427 10.948 4.22656V3.5H5.33398L8.02648 7.56102C8.2044 7.82905 8.2044 8.17095 8.02648 8.43898L5.33398 12.5H10.948V11.7896C10.948 11.3297 11.3425 10.9445 11.8244 10.9533C12.2915 10.9618 12.6673 11.3257 12.6673 11.7734V13.1797C12.6673 13.6327 12.2824 14 11.8077 14Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotal);
export default __webpack_public_path__ + "static/media/Total.65e8cddb5e3ae356ad2a2c748092737e.svg";
export { ForwardRef as ReactComponent };